<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters" style="display: flex;justify-content: space-between;width: 80%;">
        <el-form
          :inline="true"
          label-width="60px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('CargoMsg.Cargo_AirlineCode')">
            <el-input
              v-model="filter.code"
              style="width: 220px"
              :placeholder="$t('CargoMsg.Cargo_PlsInput') + $t('CargoMsg.Cargo_AirlineCode')"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ChineseName')">
            <el-input
              v-model="filter.name"
              style="width: 220px"
              :placeholder="$t('CargoMsg.Cargo_PlsInput') + $t('CargoMsg.Cargo_ChineseName')"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_EnglishName')">
            <el-input
              v-model="filter.nameEnglish"
              style="width: 220px"
              :placeholder="$t('CargoMsg.Cargo_PlsInput') + $t('CargoMsg.Cargo_EnglishName')"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfCreation2')">
            <el-date-picker
              v-model="rangeDateDateCreated"
              type="daterange"
              value-format="yyyy-MM-dd"
              :start-placeholder="$t('Tool.BeginDate')"
              :end-placeholder="$t('Project.EndtDate')"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="onAdd()">{{ $t('common.btn.new') }}</el-button>
        <!--        <el-button no="exportExcel" type="primary" @click="exportExcel">{{ $t('common.btn.exportExcel') }}</el-button>-->
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        config-module="101400"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>

    <commerce-edit-dialog
      :v-if="commerceDialog.visible"
      :visible.sync="commerceDialog.visible"
      :is-edit="commerceDialog.isEdit"
      :title="commerceDialog.title"
      :commerce="commerceDialog.form"
    />

  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { delCommerce, getCommerceList, queryCommerceDetail } from '@/api/basicData/commerce'
import commerceEditDialog from '@/views/cargo/v0/Information/components/basicData/commerceEditDialog.vue'
import { DocumentManage } from '@/utils/commonUtil'

export default {
  name: 'Commerce',
  components: { commerceEditDialog, cargoAdvanceSelect },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      filter: {
        code: '',
        name: '',
        nameEnglish: '',
        minDateCreated: '',
        maxDateCreated: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [] // 去掉每列的菜单
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AirlineCode'),
          field: 'code',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'name',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'nameEnglish',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Creator'),
          field: 'createdBy',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.DateOfCreation2'),
          field: 'dateCreated',
          colId: 'dateCreated',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UpdatePerson'),
          field: 'modifiedBy',
          colId: 'modifiedBy',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.DateModified'),
          field: 'dateModified',
          colId: 'dateModified',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Operation'),
          field: 'operation',
          suppressMenu: true,
          width: 140,
          cellRenderer: params => {
            const onView = this.documentManage.getPath('onView')
            const onEdit = this.documentManage.getPath('onEdit')
            const onDel = this.documentManage.getPath('onDel')
            return `<div>
                        <a onclick="${onView}('${params.data.uuid}')" style="color:#1F75D5;font-size:12px;">${this.$t('CargoMsg.Cargo_View')}</a>
                        <a onclick="${onEdit}('${params.data.uuid}')" style="color:#1F75D5;font-size:12px;">${this.$t('CargoMsg.Cargo_Edit')}</a>
                        <a onclick="${onDel}('${params.data.uuid}')" style="color:red;font-size:12px;">${this.$t('CargoMsg.Cargo_Delete')}</a>
                      </div>`
          }
        }
      ],
      rowData: null,
      documentManage: new DocumentManage(),
      commerceDialog: {
        visible: false,
        title: '',
        isEdit: false,
        form: {
          uuid: '',
          code: '',
          name: '',
          nameEnglish: '',
          remark: '',
          commerceResponsiblePersonVos: []
        }
      },
      allList: [],
      seaList: [],
      airList: [],
      rangeDateDateCreated: ''
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  watch: {
    rangeDateDateCreated(newVal) {
      if (newVal) {
        this.filter['minDateCreated'] = newVal[0]
        this.filter['maxDateCreated'] = newVal[1]
      } else {
        this.filter['minDateCreated'] = ''
        this.filter['maxDateCreated'] = ''
      }
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onView', function(value) {
      context.onView(value)
    })
    this.documentManage.set('onEdit', function(value) {
      context.onEdit(value)
    })
    this.documentManage.set('onDel', function(value) {
      context.onDel(value)
    })
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      getCommerceList(self.filter).then(res => {
        self.rowData = res.data.list
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    onDel(commerceUuid) {
      const self = this
      if (!commerceUuid) {
        return
      }
      console.log('rowData is', this.rowData)
      const commerce = this.rowData.find(p => p.uuid === commerceUuid)
      if (commerce) {
        self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
          confirmButtonText: self.$t('common.btn.ok'),
          cancelButtonText: self.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          delCommerce(commerceUuid).then(res => {
            self.filter.pageNum = 1
            self.toQuery()
          }).catch(() => {})
        })
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    onAdd() {
      this.showEditDialog(true, true, null)
    },
    onView(commerceUuid) {
      this.showEditDialog(false, false, commerceUuid)
    },
    onEdit(commerceUuid) {
      this.showEditDialog(false, true, commerceUuid)
    },
    async showEditDialog(isNew, isEdit, commerceUuid = null) {
      if (isNew) {
        this.commerceDialog.form = {
          uuid: '',
          code: '',
          name: '',
          nameEnglish: '',
          remark: '',
          commerceResponsiblePersonVos: []
        }
        this.commerceDialog.isEdit = true
        this.commerceDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_BusinessManager')
        this.commerceDialog.visible = true
      } else {
        if (!commerceUuid || commerceUuid.length === 0) {
          return
        }
        const commerce = await queryCommerceDetail(commerceUuid).then(res => res.data)
        if (commerce) {
          this.commerceDialog.form = commerce
          this.commerceDialog.isEdit = isEdit
          const label = isEdit ? this.$t('CargoMsg.Cargo_EditTo') : this.$t('CargoMsg.Cargo_View')
          this.commerceDialog.title = label + this.$t('CargoMsg.Cargo_BusinessManager')
          this.commerceDialog.visible = true
        }
      }
    },
    exportExcel() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          self.$t('CargoMsg.Cargo_AirlineCode'),
          self.$t('CargoMsg.Cargo_ChineseName'),
          self.$t('CargoMsg.Cargo_EnglishName'),
          self.$t('SeaExport.DateOfCreation2'),
          self.$t('CargoMsg.Cargo_UpdatePerson'),
          self.$t('SeaExport.DateModified')
        ]
        const filterVal = ['code', 'name', 'nameEnglish', 'createdBy', 'dateCreated', 'modifiedBy', 'dateModified']
        const data = self.formatJson(filterVal, rows)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'Commerce'
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.search-form {
  max-width: 1400px;
  .el-form-item__content {
    width: 215px;
    .el-date-editor {
      width: 100%;
    }
  }
  .form-item-300 {
    .el-form-item__content {
      width: 300px;
    }
  }
  .el-checkbox {
    margin-right: 5px;
    .el-checkbox__label {
      padding-left: 2px;
    }
  }
}
</style>
